<div class="flex h-full flex-1 flex-col place-content-center items-stretch justify-between">
  <h2 [class.login-select-authentication--title]="isI4BLogin()" class="layout-login-regular-title">{{ 'LOGIN.TITLE.LOGIN' | translate }}</h2>

  <form [formGroup]="form" [class.login-form-i4b]="isI4BLogin()" class="flex flex-col">
    <mat-form-field color="accent" class="w-full">
      <mat-icon matIconPrefix>email</mat-icon>
      <mat-label>{{ 'LOGIN.EMAIL' | translate }}</mat-label>
      <input #emailInput (input)="onChangeEmail(emailInput.value)" formControlName="email" matInput type="email" />
      @if (email.invalid) {
        <mat-error>{{ (email?.errors?.email ? 'FORM.ERROR_MESSAGE.INVALID_EMAIL' : 'LOGIN.ERROR_MESSAGE.EMAIL') | translate }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field color="accent" class="w-full">
      <mat-icon matIconPrefix>lock</mat-icon>
      <mat-label>{{ 'LOGIN.PASSWORD' | translate }}</mat-label>
      <input [type]="hide() ? 'password' : 'text'" formControlName="password" matInput />
      <mat-icon (click)="onHide()" class="layout-pointer-cursor" matIconSuffix>{{ hide() ? 'visibility_off' : 'visibility' }} </mat-icon>
      @if (password.invalid) {
        <mat-error>{{ 'LOGIN.ERROR_MESSAGE.PASSWORD' | translate }}</mat-error>
      }
    </mat-form-field>

    @if (rememberMe()) {
      <mat-checkbox data-test="remember-me-checkbox" formControlName="rememberMe" (change)="onRememberMeChange($event.checked)">
        {{ 'LOGIN.REMEMBER_ME' | translate }}
      </mat-checkbox>
    }

    @if (!isI4BLogin()) {
      <div class="login-reset-pwd-button flex flex-row items-start justify-end">
        <button (click)="onResetPassword()" mat-button type="button">{{ 'LOGIN.RESET_PASSWORD' | translate }}</button>
      </div>
    }

    <div [class.error]="hasError()" class="layout-login-error flex flex-col">
      <em>{{ 'LOGIN.ERROR_MESSAGE.LOGIN_FAILED' | translate }}</em>
      <span>{{ 'LOGIN.ERROR_MESSAGE.FIX_EMAIL_PASSWORD' | translate }}</span>
    </div>

    <div [class.layout-form-actions-i4b]="isI4BLogin()" class="layout-form-actions gap-5">
      @if (isI4BLogin() && !ssoDisabled()) {
        <button (click)="cancel.emit()" class="layout-login-button" mat-button type="button">{{ 'LOGIN.BUTTON.CANCEL' | translate }}</button>
      }

      <iot-platform-ui-progress-bar-button
        (clickEvent)="onSignIn()"
        [disabled]="form.invalid"
        [enableGauge]="enableGauge() && !hasError()"
        [gaugeColor]="'accent'"
        [title]="'LOGIN.BUTTON.SIGN_IN' | translate"
        type="submit"
      ></iot-platform-ui-progress-bar-button>
    </div>
  </form>

  @if (isI4BLogin()) {
    <span (click)="onResetPassword()" class="login-reset-pwd-button-i4b" role="button" tabindex="0">{{ 'LOGIN.RESET_PASSWORD' | translate }}</span>
  }
</div>
